export const cardsList = {
    show: {
        /** Display AT specific field sbDeckelungsLimits.maximumIndoorWithdrawalLimit */
        withdrawalLimit: true,
    },
};
